import ConfigureCurb from './ConfigureCurbWrapper';

export default ConfigureCurb;
